import React from "react";
import { useTranslation } from "react-i18next";
import { PostalCodesActions } from "./constants";
import { $Popconfirm } from "us.common/components";
import { EditOutlined, DeleteOutlined, CloseCircleFilled } from "us.icons";
import { IItemMenu } from "./interface";

const ItemMenu: React.FC<IItemMenu> = ({ onCallAction }) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      <div
        className="d-flex  flex-row more-item"
        data-testid="edit-btn"
        onClick={() => onCallAction(PostalCodesActions.EDIT)}
      >
        <div className="p-1">
          <EditOutlined />
        </div>
        <div className="p-1">{t("US.COMMON:COMMON.EDIT")}</div>
      </div>

      {
        <$Popconfirm
          title={t("US.COMMON:COMMON.DO_YOU_WANT_TO_DELETE_THE_POSTAL_AREA")}
          onConfirm={() => onCallAction(PostalCodesActions.DELETE)}
        >
          <div
            className="d-flex mb-2 flex-row more-item text-error"
            data-testid="delete-btn"
          >
            <div className="p-1">
              <DeleteOutlined />
            </div>
            <div className="p-1">{t("US.COMMON:COMMON.DELETE")}</div>
          </div>
        </$Popconfirm>
      }
    </div>
  );
};

export default ItemMenu;
